// extracted by mini-css-extract-plugin
export var id_bg_06 = "RecruitLowerHeaderBg-module--id_bg_06--tafir";
export var bg_06 = "RecruitLowerHeaderBg-module--bg_06--_xnFO";